export default "__VITE_ASSET__126adb55__"